import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=c3c06d5a&"
import script from "./tab.vue?vue&type=script&lang=ts&"
export * from "./tab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports